import { isEqual } from 'lodash';
import {
  IFilterComparator,
  InclusiveExclusiveFilterModel
} from '../../filter-types';
import { excludeValues } from '../../filter-utils';

export class InclusiveExclusiveModelComparator
  implements IFilterComparator<InclusiveExclusiveFilterModel> {
  private optionValues: string[];

  applyFilterOptions(options: string[]) {
    this.optionValues = options;
  }

  hasValidDiff(
    grid: Partial<InclusiveExclusiveFilterModel>,
    store: InclusiveExclusiveFilterModel
  ): boolean {
    if (isEqual(grid, store)) {
      return false;
    } else {
      if (!grid) {
        if (!store.isInclusive) {
          return this.optionValues.some(
            ov => store.storeValues.indexOf(ov) !== -1
          );
        } else {
          return true;
        }
      }
      const storeGridDiff: string[] = excludeValues(store.values, grid.values);
      const gridStoreDiff: string[] = excludeValues(grid.values, store.values);
      if (storeGridDiff.length === 0 && gridStoreDiff.length === 0) {
        return false;
      }
      const fullDiff: string[] = excludeValues(
        storeGridDiff,
        this.optionValues
      );
      return fullDiff.length === 0;
    }
  }
}
